"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownOutline = _interopRequireDefault(require("./IconArrowDownOutline"));
var IconArrowLeftOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownOutline.default).withConfig({
  displayName: "IconArrowLeftOutline",
  componentId: "c11n-8-107-0__sc-daxcpt-0"
})(["transform:rotate(90deg);"]);
var _default = IconArrowLeftOutline;
exports.default = _default;